module.exports = __webpack_public_path__ + "img/tutorial07.c111d69f.svg";